<template>
  <div v-bind="attrs">
    <svg
      :width="width || 18"
      :height="height || 18"
      viewBox="0 0 400 400"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        ref="path"
        d="M80.665 1.207C64.286 5.618 51.267 20.95 46.864 41.016c-.471 2.148-11.208 41.96-23.86 88.471S0 214.585 0 215.235c0 .835 1.356.257 4.607-1.961C24.863 199.447 16.518 200.013 200 200.013s175.137-.566 195.393 13.261c3.257 2.223 4.607 2.797 4.607 1.959 0-2.208-48.358-178.874-50.162-183.257-6.671-16.205-17.878-27.432-30.725-30.778-6.644-1.731-232.019-1.722-238.448.009m158.108 46.87c53.082 6.958 83.203 33.049 83.45 72.286.05 7.822-1.787 11.575-7.523 15.373l-3.256 2.155h-26.23c-39.119 0-38.017.872-38.488-30.492-.485-32.384 1.682-31.002-48.096-30.672l-34.177.226-3.506 1.963c-6.845 3.833-7.388 5.842-7.699 28.483-.428 31.272.534 30.492-37.623 30.492-28.072 0-28.434-.044-32.787-3.976-5.794-5.235-6.748-12.643-3.545-27.529 6.802-31.607 35.291-52.044 81.254-58.289 11.752-1.596 66.096-1.611 78.226-.02M38.281 215.635c-17.673 3.117-32.607 16.814-37.087 34.015-1.671 6.415-1.676 32.503-.008 39.053C5.26 304.7 18.442 317.7 34.841 321.894c5.794 1.482 8.889 1.544 77.784 1.544h71.75v45.312l-54.102.019c-29.755.01-55.461.334-57.124.72-13.549 3.143-15.875 22.692-3.454 29.032 4.74 2.419 255.458 2.301 260.464-.123 5.106-2.471 9.116-8.779 8.463-13.312-.964-6.696-1.423-8.031-3.62-10.533-5.05-5.752-.956-5.388-63.322-5.632l-56.055-.22V323.438h71.75c87.504 0 85.051.346 99.344-14.029 10.837-10.9 13.281-18.311 13.281-40.268 0-28.843-9.248-43.879-32.031-52.079l-5.078-1.828-160.547-.109c-88.301-.061-162.129.169-164.063.51m24.673 33.104c10.218 4.757 15.574 15.983 12.563 26.326-6.166 21.18-34.993 22.302-42.72 1.664-6.794-18.145 12.615-36.159 30.157-27.99m77.829.427c20.872 10.542 13.385 42.436-9.962 42.436-19.941 0-29.918-24.412-15.686-38.379 6.603-6.48 17.453-8.197 25.648-4.057m76.795-.153c21.168 10.942 13.58 42.676-10.172 42.539-23.566-.136-30.655-31.663-9.523-42.353 5.883-2.976 14.147-3.054 19.695-.186m137.634-.242c10.904 5.077 16.059 17.094 11.991 27.958-7.727 20.638-36.554 19.516-42.72-1.664-5.174-17.772 13.927-34.117 30.729-26.294"
        fill="#1C2025"
      />
    </svg>
  </div>
</template>
<script>
export default {
  props: ["width", "height"],
  computed: {
    attrs() {
      return {
        ...this.$attrs,
        class: this.$attrs.className,
      };
    },
  },
  mounted() {
    if (!this.$refs.path) {
      return;
    }

    if (this.$attrs.color) {
      this.$refs.path.setAttribute("fill", this.$attrs.color);
    }
  },
};
</script>
